/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */
import { convertToRem } from '../../utils/pixel-to-rem-convertor.js';

const marginPadding = 16;
export const WorklineFloatPositionerMixin = (superClass) =>
  class extends superClass {
    static get properties() {
      return {
        /** @ignore */
        _floatPositions: { type: Object, reflect: false },
      };
    }
    /**
     *function for to calculate and get postion to start and stop float, margin
     */
    calculateFloatPositions() {
      const floatElements = this.querySelectorAll('sh-workline-item[float]');
      if (floatElements.length == 0) return;

      const BodyChilds = this.shadowRoot.querySelector('#body').assignedNodes({
        flatten: true,
      });

      let allChildren = [];

      for (let index = 0; index < BodyChilds.length; index++) {
        if (BodyChilds[index].tagName == 'SH-WORKLINE-GROUP') {
          let worklineGroup = BodyChilds[index].childNodes;
          for (let index1 = 0; index1 < worklineGroup.length; index1++) {
            if (worklineGroup[index1].tagName == 'SH-WORKLINE-ITEM') {
              allChildren.push(worklineGroup[index1]);
            }
          }
        } else if (BodyChilds[index].tagName == 'SH-WORKLINE-ITEM') {
          allChildren.push(BodyChilds[index]);
        }
      }

      const workline = this.shadowRoot.querySelector('.workline-wrapper');
      const total = this.shadowRoot.querySelector('.total-wrapper');
      let worklineLeft = workline.getBoundingClientRect().x - total.getBoundingClientRect().x;
      let worklineRight = worklineLeft + workline.getBoundingClientRect().width;

      let leftFloatMarginLists = this._getLeftPositionAfterfloat(floatElements, worklineLeft);
      let leftFloatPosLists = this._getLeftPositionTostartfloat(allChildren, floatElements);

      let fixRightList = this._getRightFixedElement(allChildren, floatElements);
      let rightFloatPosLists = this._getRightPositionTostartfloat(
        floatElements,
        fixRightList,
        worklineLeft,
        worklineRight
      );

      let rightFloatMarginLists = [];
      rightFloatMarginLists[floatElements.length - 1] = convertToRem(
        worklineRight -
          floatElements[floatElements.length - 1].getBoundingClientRect().width -
          marginPadding -
          marginPadding
      );
      rightFloatMarginLists = this._rightPositionAfterfloat(floatElements, rightFloatMarginLists);

      this._floatPositions = {
        leftFloatPosLists: leftFloatPosLists,
        rightFloatPosLists: rightFloatPosLists,
        leftFloatMarginLists: leftFloatMarginLists,
        rightFloatMarginLists: rightFloatMarginLists,
      };
    }
    /**
     * On scroll, start/stop fix
     */
    fixFloatItems() {
      let floatElements = this.querySelectorAll('sh-workline-item[float]');
      if (floatElements.length == 0) return;
      let scrollelement = this.shadowRoot.querySelector('.workline-wrapper');
      for (let i = 0; i < floatElements.length; i++) {
        const fixedEl = floatElements[i];
        const refLeft = this._floatPositions.leftFloatPosLists[i];
        const refRight = this._floatPositions.rightFloatPosLists[i];
        if (convertToRem(scrollelement.scrollLeft) > refLeft) {
          this._leftFloatFix(fixedEl, this._floatPositions.leftFloatMarginLists, i);
          this._updateFloatwrapper('leftfix', this.shadowRoot.querySelector('.left-float'));
        } else if (convertToRem(scrollelement.scrollLeft) < refRight) {
          this._rightFloatFix(fixedEl, this._floatPositions.rightFloatMarginLists, i);
          this._updateFloatwrapper('rightfix', this.shadowRoot.querySelector('.right-float'));
        } else {
          this._removeFloatFix(fixedEl);
        }
      }
    }
    _rightFloatFix(fixedElement, rightPosList, index) {
      let elementWidth = 0;
      //last element add extra margin
      let IsLastElement =
        this.shadowRoot
          .querySelector('#body')
          .assignedNodes({
            flatten: true,
          })
          .filter((x) => x.tagName == 'SH-WORKLINE-ITEM')
          .reverse()[0] === fixedElement;
      if (IsLastElement) {
        elementWidth = fixedElement.getBoundingClientRect().width + marginPadding;
      } else {
        elementWidth = fixedElement.getBoundingClientRect().width;
      }
      fixedElement.previousElementSibling.style.minWidth = convertToRem(elementWidth) + 'rem';
      fixedElement.previousElementSibling.style.marginLeft = '1rem';
      fixedElement.previousElementSibling.style.visibility = 'visible';
      fixedElement.classList.add('rightfix');
      fixedElement.style.left = rightPosList[index] + 'rem';
    }
    _leftFloatFix(fixedElement, leftFloatMarginLists, index) {
      fixedElement.previousElementSibling.style.marginLeft = '1rem';
      fixedElement.previousElementSibling.style.minWidth =
        convertToRem(fixedElement.getBoundingClientRect().width) + 'rem';
      fixedElement.previousElementSibling.style.visibility = 'visible';
      fixedElement.classList.add('leftfix');
      fixedElement.style.left = leftFloatMarginLists[index] + 'rem';
    }
    _updateFloatwrapper(fix, floatwrapper) {
      let wrapperWidth = 0;
      this.querySelectorAll('sh-workline-item[float]').forEach((element) => {
        if (element.classList.contains(fix)) {
          wrapperWidth += element.getBoundingClientRect().width + marginPadding;
        }
      });
      floatwrapper.style.zIndex = '2';
      floatwrapper.style.minWidth = convertToRem(wrapperWidth) + 'rem';
    }
    _removeFloatFix(fixedElement) {
      if (fixedElement.classList.contains('leftfix')) {
        fixedElement.classList.remove('leftfix');
        fixedElement.style.left = '0rem';
        fixedElement.previousElementSibling.style.minWidth = '0rem';
        fixedElement.previousElementSibling.style.marginLeft = '0rem';
        fixedElement.previousElementSibling.style.visibility = 'collapse';
        this._updateFloatwrapper('leftfix', this.shadowRoot.querySelector('.left-float'));
      } else if (fixedElement.classList.contains('rightfix')) {
        fixedElement.classList.remove('rightfix');
        fixedElement.style.left = '0rem';
        fixedElement.previousElementSibling.style.minWidth = '0rem';
        fixedElement.previousElementSibling.style.marginLeft = '0rem';
        fixedElement.previousElementSibling.style.visibility = 'collapse';
        this._updateFloatwrapper('rightfix', this.shadowRoot.querySelector('.right-float'));
      }
    }
    _getLeftPositionAfterfloat(floatElements, worklineLeft) {
      let leftPosSum = worklineLeft;
      let leftPosList = [];
      for (let i = 0; i < floatElements.length; i++) {
        const fixedEl = floatElements[i];
        if (i === 0) {
          leftPosList[0] = convertToRem(leftPosSum);
        } else {
          leftPosList[i] = convertToRem(leftPosSum);
        }
        leftPosSum += fixedEl.getBoundingClientRect().width + marginPadding;
      }
      return leftPosList;
    }
    _getLeftPositionTostartfloat(allChildren, floatElements) {
      let leftPosSum = 0;
      let refLeftList = [];

      for (let i = 0; i < floatElements.length; i++) {
        let fixLeft = 0;
        const fixedEl = floatElements[i];
        const fixedElIndex = Array.from(allChildren).indexOf(fixedEl);
        for (let i = 0; i < fixedElIndex; i++) {
          fixLeft += allChildren[i].getBoundingClientRect().width + marginPadding;
        }
        if (i === 0) {
          refLeftList[i] = convertToRem(fixLeft);
        } else {
          refLeftList[i] = convertToRem(fixLeft - leftPosSum);
        }
        leftPosSum += fixedEl.getBoundingClientRect().width + marginPadding;
      }
      return refLeftList;
    }
    _getRightFixedElement(allChildren, floatElements) {
      let fixRightList = [];
      for (let i = 0; i < floatElements.length; i++) {
        let fixLeft = 0;
        const fixedEl = floatElements[i];
        const fixedElIndex = Array.from(allChildren).indexOf(fixedEl);
        for (let i = 0; i < fixedElIndex; i++) {
          fixLeft += allChildren[i].getBoundingClientRect().width + marginPadding;
        }
        if (i == 0) {
          fixRightList[i] = convertToRem(fixLeft + fixedEl.getBoundingClientRect().width);
        } else {
          fixRightList[i] = convertToRem(
            fixLeft + fixedEl.getBoundingClientRect().width + marginPadding
          );
        }
      }
      return fixRightList;
    }
    _getRightPositionTostartfloat(floatElements, fixRightList, worklineLeft, worklineRight) {
      let refRightList = [];
      let rightPosSum = 0;
      for (let i = 0; i < floatElements.length; i++) {
        let j = floatElements.length - 1 - i;
        const fixedEl = floatElements[j];
        if (j === floatElements.length - 1) {
          refRightList[j] =
            fixRightList[j] +
            convertToRem(worklineLeft) -
            convertToRem(worklineRight) +
            convertToRem(marginPadding + 0.0001); //flickering issue,so added
        } else {
          refRightList[j] =
            fixRightList[j] +
            convertToRem(worklineLeft) -
            convertToRem(worklineRight) +
            convertToRem(rightPosSum) +
            convertToRem(marginPadding);
        }

        rightPosSum += fixedEl.getBoundingClientRect().width + marginPadding;
      }
      return refRightList;
    }
    _rightPositionAfterfloat(floatElements, rightPosList) {
      for (let i = 0; i < floatElements.length; i++) {
        let j = floatElements.length - 1 - i;
        if (j !== floatElements.length - 1) {
          const fixedEl = floatElements[j];
          rightPosList[j] =
            rightPosList[j + 1] -
            convertToRem(marginPadding) -
            convertToRem(fixedEl.getBoundingClientRect().width);
        }
      }
      return rightPosList;
    }
  };
